import {
  AddOnFeeCategory,
  AddOnFees,
  FeeCalculationType,
  IContractDetailsResponseData,
  UserProfile,
} from "../api/services/contract/models";

/**
 * Matches an entry of `partiesProfiles` back to its entry in `parties`.
 *
 * Both sides of a key must be present before it is compared: an unregistered
 * profile carries no `userIdentification` and an unregistered party carries a
 * `userId` of null, so a loose `==` comparison pairs any unregistered profile
 * with the first unregistered party of the contract — regardless of role — and
 * the row then shows that other party's amount, fee and status.
 */
export const findPartyForProfile = (
  parties: Partial<UserProfile>[] | undefined,
  profile:
    | { phoneNumber?: string; userIdentification?: number | string }
    | undefined
) =>
  parties?.find(
    (party) =>
      (!!profile?.phoneNumber && party?.phoneNumber === profile.phoneNumber) ||
      (profile?.userIdentification != null &&
        party?.userId != null &&
        String(party.userId) === String(profile.userIdentification))
  );

export const getShipmentFeesTotal = (
  contract?: IContractDetailsResponseData
) => {
  if (!contract?.addonFeesList?.length || contract?.itemPrice == null) return 0;
  const addonShippingFees = contract?.addonFeesList?.filter(
    (fee) => fee.type === AddOnFeeCategory.SHIPPING_FEES
  );
  const total =
    addonShippingFees?.reduce?.((acc: number, addOnFee: AddOnFees) => {
      if (addOnFee.feeType === FeeCalculationType.FLAT) {
        return acc + addOnFee.amount;
      } else if (addOnFee.feeType === FeeCalculationType.PERCENTAGE) {
        return acc + (contract?.itemPrice * addOnFee.amount) / 100;
      }
      return acc;
    }, 0) ??
    contract?.shipment?.fee ??
    0;
  return total;
};
